export const RX_PROPERTIES = {
  rxTop: "",
  rxLeft: "",
  rxBottom: "",
  rxRight: "",
};

export const UPLOADING_FOR = {
  VIRTUAL_CLINIC: "virtual_clinic",
  OTHER_CLINIC: "other_clinic",
};
